import { useParams, useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { Button } from '@/common/ui/button'
import { ArrowLeft } from 'lucide-react'
import { Card, CardContent } from '@/common/ui/card'
import OtpProviderForm from '@/modules/otp-provider/components/OtpProviderForm'
import useQueryGetOtpProvider from '@/modules/otp-provider/api/hooks/useQueryGetOtpProvider'

function EditOtpProviderPage() {
	const { id } = useParams<{ id: string }>()
	const navigate = useNavigate()

	const { data: provider, isLoading, error } = useQueryGetOtpProvider(id!)

	useEffect(() => {
		if (!id) {
			navigate('/operator/otp-provider')
		}
	}, [id, navigate])

	useEffect(() => {
		if (error) {
			navigate('/operator/otp-provider')
		}
	}, [error, navigate])

	const handleSuccess = () => {
		navigate('/operator/otp-provider')
	}

	const handleBack = () => {
		navigate('/operator/otp-provider')
	}

	if (!id) return null

	if (isLoading) {
		return (
			<PageContainer>
				<div className="mx-auto max-w-2xl">
					<div className="mb-6 flex items-center gap-4">
						<Button variant="outline" size="sm" onClick={handleBack}>
							<ArrowLeft className="mr-2 h-4 w-4" />
							กลับ
						</Button>
						<h1 className="text-2xl font-semibold">แก้ไขผู้ให้บริการ OTP</h1>
					</div>
					<Card>
						<CardContent className="p-6">
							<div className="flex h-32 items-center justify-center">
								<div className="text-muted-foreground">กำลังโหลด...</div>
							</div>
						</CardContent>
					</Card>
				</div>
			</PageContainer>
		)
	}

	return (
		<PageContainer>
			<div className="mx-auto max-w-2xl">
				<div className="mb-6 flex items-center gap-4">
					<Button variant="outline" size="sm" onClick={handleBack}>
						<ArrowLeft className="mr-2 h-4 w-4" />
						กลับ
					</Button>
					<h1 className="text-2xl font-semibold">แก้ไขผู้ให้บริการ OTP</h1>
				</div>
				<OtpProviderForm
					mode="edit"
					providerId={id}
					initialData={provider}
					onSuccess={handleSuccess}
				/>
			</div>
		</PageContainer>
	)
}

export default withUserPermission(EditOtpProviderPage, {
	permissionType: PermissionType.Write,
	permissionKey: [PermissionKeys.WEB_SETTING],
})
